angular.module('account').factory('AccountRepository',
    ['AprimaRestangular', 'MetadataRepository', function (AprimaRestangular, MetadataRepository) {
        'use strict';

        function postChangePassword(changePasswordDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/'+ changePasswordDto.Id +'/changepassword/').customPOST(changePasswordDto);
        }

        function getOptOutOfEmaiDetails(params) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('optout/email/getoptoutofemaildetails/').get(params);
        }

        function postOptOutEmail(emailOptOutDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('optout/email/optoutofemail/').customPOST(emailOptOutDto);
        }

        function postForgotPassword(changePasswordDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/changepassword/').customPOST(changePasswordDto);
        }

        function postAccountActivationRequest(activatePatientPortalAccountRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/activate-account-request/').customPOST(activatePatientPortalAccountRequestDto);
        }

        function postAccountActivation(activatePatientPortalAccountDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/activate-account/').customPOST(activatePatientPortalAccountDto);
        }

        function postAccountActivationIdValidation(clientId, activationId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/activate-account-request-validation/' + activationId).customPOST(clientId);
        }

        function postUserNameValidation(clientId, userName) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/username-validation/' + userName).customPOST(clientId);
        }

        function getSecurityQuestions(userName, clientId) {
            var restangular = AprimaRestangular.get('patient');
            var params = {
                userName: userName,
                clientId: clientId
            };
            return restangular.one('security/securityquestions/').get(params);
        }

        function getCredentialsMetadata($scope) {
            return MetadataRepository.getMetadata('account-details/credentials', $scope);
        }

        function getSecurityQuestionsAnswersMetadata($scope) {
            return MetadataRepository.getMetadata('account-details/security-questions-answers', $scope);
        }

        function getActivatePatientPortalRequestMetadata($scope) {
            return MetadataRepository.getMetadata('account-details/activate-patient-portal-request', $scope);
        }

        function getActivatePatientPortalMetadata($scope) {
            return MetadataRepository.getMetadata('account-details/activate-patient-portal', $scope);
        }

        function getAccountDetails(loginUserId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/'+ loginUserId +'/account-details/').get();
        }

        function putAccountCredentials(securityAccountCredentialsDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/'+ securityAccountCredentialsDto.LoginUserId +'/credentials').customPUT(securityAccountCredentialsDto);
        }

        function putSecurityQuestionsAnswers(securityAccountQuestionsAnswersDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('security/'+ securityAccountQuestionsAnswersDto.LoginUserId +'/questions-answers').customPUT(securityAccountQuestionsAnswersDto);
        }


        return{
            postChangePassword: postChangePassword,
            postOptOutEmail: postOptOutEmail,
            getOptOutOfEmaiDetails: getOptOutOfEmaiDetails,
            postForgotPassword: postForgotPassword,
            getSecurityQuestions: getSecurityQuestions,
            getAccountDetails: getAccountDetails,
            putAccountCredentials: putAccountCredentials,
            putSecurityQuestionsAnswers: putSecurityQuestionsAnswers,
            getCredentialsMetadata: getCredentialsMetadata,
            getSecurityQuestionsAnswersMetadata: getSecurityQuestionsAnswersMetadata,
            postAccountActivationRequest: postAccountActivationRequest,
            postAccountActivation: postAccountActivation,
            postAccountActivationIdValidation: postAccountActivationIdValidation,
            postUserNameValidation: postUserNameValidation,
            getActivatePatientPortalRequestMetadata: getActivatePatientPortalRequestMetadata,
            getActivatePatientPortalMetadata: getActivatePatientPortalMetadata
        };
    }]);